
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's5b7ca741f9246d12': `Herzlichen Dank!`,
's90de8980c73e442b': `Ihre Anfrage ist bei uns eingegangen.`,
's2b65fcba4f882ed8': `Sie erhalten innerhalb von 48 Stunden eine Rückmeldung von uns.`,
's2905f7b58be224ef': `Ihr KUONI Team`,
's942feefaf37ce8d4': `Zurück zum Angebot`,
's8574d5c3c3731cef': `Haben Sie Fragen? Kontaktieren Sie unsere Experten unter`,
'se9cd616a129d76e4': `Reisezeitraum`,
's82badbeb3be9c782': `Preis pro Person`,
's089c4407b545986a': `ab`,
's11cba9ac69a050ec': `Teilen Sie uns Ihren Wunschzeitraum oder mögliche Alternativen mit`,
's6064a8ed3411278c': `Reiseteilnehmer`,
's1dfd8aad3ccd9347': `Anzahl Personen`,
's78bb5da2bfa9e69d': `(ab 13 Jahre)`,
'sa026193d0982c3c4': `Anzahl Kinder`,
's9145cec5896965b7': `(bis 12 Jahre)`,
's4794acf374b0320f': `Alter Kind`,
'saf63a04c86018698': `-`,
's2618ab80606e96d3': `Die Richtpreise gelten pro erwachsene Person im Doppelzimmer. Bei ungerader Anzahl Personen kann sich der Gesamtpreis ändern.`,
'sca5449aa9009dadf': `Optionale Zusatzleistungen`,
's55d6064b5307f215': `Ich wünsche einen Flugofferte dazu`,
's05f1a0b70078e78a': `Ich wünsche ein Vor- oder Anschlussprogramm`,
'sb3ec52a339a36d4a': `Ich wünsche Ausflugsvorschläge`,
'seefcaf121c27243d': `Mitteilung`,
'sb68e190d580d59e0': `Mehrkosten durch Anpassungen oder Zusatzleistungen weisen wir transparent in der Offerte aus.`,
's476f5d3d5143d4d8': `Anrede`,
'sa67c3584d609b83f': `Frau`,
's34dc17d860d2efba': `Herr`,
's78a62d35a630c984': `Divers`,
'sd72cac450c159603': `Vorname`,
's4e9995a5ac28f038': `Nachname`,
'sab1114a5f102dedc': `Telefon`,
's6775d2d0f1d5b365': `Bitte geben Sie eine gültige Telefonnummer ein.`,
's63e457bc703a3030': `E-Mail`,
's85f2b6f2f08fe262': `Wählen Sie Ihr Reisebüro`,
's6bec47f8e7d7f845': `Bitte wählen`,
'sb2d649e7dd0e0cf4': `eMail Confirmation`,
'sb44d8e5feaffc4df': `Für den Fall, dass keine Buchung erfolgt, akzeptiere ich eine Beratungspauschale von CHF 150.– (voll anrechenbar bei Buchung).*`,
's5f8f4fddf2eca090': `Ich möchte den personalisierten Newsletter erhalten.`,
's4bfb1b187d6b7309': `Ihre Daten bearbeiten wir gemäss unserer`,
'sf9c72fd7f187b4a2': `https://www.kuoni.ch/datenschutz`,
's66a8ea9d4609abf8': `Datenschutzerklärung`,
's722205a7f93b510b': `Es ist leider ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.`,
's3026a7ba9aefb549': `Anfrage absenden`,
's14b76ac03be4da81': `Ihre Kontaktdaten`,
    };
  